import { useEffect } from "react";
import { useSetRecoilState } from "recoil";

import { getLastDayOfTwoMonthsLater } from "../../utils/date-format/dateUtils";
import { ServerCalendarBlockType } from "../../types/block/BlockType";
import { mobaCalendarListState } from "../../recoil/calendar/mobaCalendarListState";
import { useProcessCalendarBlocks } from "./useProcessCalendarBlocks";

export function useInitializeCalendarState(
  serverData: ServerCalendarBlockType[] | undefined,
  isFetching: boolean,
  calendarLastMonth: string | null
) {
  const setMobaCalendarList = useSetRecoilState(mobaCalendarListState);
  const { processInitialCalendarBlocks } = useProcessCalendarBlocks();

  useEffect(() => {
    if (!serverData || isFetching) return;
    if (serverData.length === 0) {
      // 서버 데이터가 빈 경우 초기화 안함
      // 초기화 시점에 serverData가 아직 도착하지 않았지만 []로 들어와서, setMobaCalendarList([])로 초기화가 되어버리는 현상을 막기 위해
      return;
    }

    const recurringEnd = calendarLastMonth
      ? getLastDayOfTwoMonthsLater(calendarLastMonth)
      : new Date();

    const initialProcessedCalendarBlocks = processInitialCalendarBlocks(serverData, recurringEnd);

    setMobaCalendarList(initialProcessedCalendarBlocks);
  }, [serverData, isFetching, calendarLastMonth]);
}
